import { ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { IncomeExpensesBarLegendToggle } from './IncomeExpensesBarLegendToggle';
import type { IncomeExpensesBarLegendEntry } from './IncomeExpensesBarTypes';

export type IncomeExpensesBarLegendProps = {
    incomeEntries: IncomeExpensesBarLegendEntry[];
    expenseEntries: IncomeExpensesBarLegendEntry[];
    hiddenSeries: ReadonlySet<number>;
    onToggleSeries: (seriesIndex: number) => void;
};

export const IncomeExpensesBarLegend: FunctionComponent<IncomeExpensesBarLegendProps> = ({ incomeEntries, expenseEntries, hiddenSeries, onToggleSeries }) => (
    <ZfStack direction="column" spacing="medium">
        <ZfStack direction="row" spacing="large">
            {incomeEntries.length
                ? incomeEntries.map((entry) => (
                      <IncomeExpensesBarLegendToggle
                          key={entry.seriesIndex}
                          entry={entry}
                          hidden={hiddenSeries.has(entry.seriesIndex)}
                          onToggleSeries={onToggleSeries}
                      />
                  ))
                : null}
        </ZfStack>
        <ZfStack direction="row" spacing="large">
            {expenseEntries.length
                ? expenseEntries.map((entry) => (
                      <IncomeExpensesBarLegendToggle
                          key={entry.seriesIndex}
                          entry={entry}
                          hidden={hiddenSeries.has(entry.seriesIndex)}
                          onToggleSeries={onToggleSeries}
                      />
                  ))
                : null}
        </ZfStack>
    </ZfStack>
);
